import React from 'react';
import { Route, Switch } from 'react-router-dom';
import P, { InferProps } from 'prop-types';
import NewsList from './news-list';

function News({ match }: InferProps<typeof News.propTypes>) {
  return (
    <Switch>
      <Route exact path={`${match.url}/:abbrv`} component={NewsList} />
    </Switch>
  );
}

News.propTypes = {
  match: P.shape({
    url: P.string.isRequired,
  }).isRequired,
};

export default News;
